function getCartItemQuantity(orderItems) {
  const cartItemQuantity = orderItems.reduce((acc, curr) => {
    let total = acc;

    if (curr.units) {
      total += curr.quantity * curr.units;
    }
    else {
      total += curr.quantity;
    }

    return total;
  }, 0);

  return cartItemQuantity;
}

export { getCartItemQuantity };

